<app-maintenance *ngIf="maintenance"></app-maintenance>

<nav *ngIf="!maintenance && loggedIn" class="navbar navbar-expand-lg navbar-light bg-light mb-3">

  <div class="logo-wrapper">
    <div class="logo-wrapper-inner">
      <img src="../assets/images/cop4all_schriftzug_50p.png" alt="Cop4ALL Schriftzug"><span class="version">v{{currentAppVersion}}</span>
    </div>
    <span class="navbar-brand">Copernicus für ALKIS und Landbedeckung</span>
  </div>
  <span class="spacer"></span>
  <button class="navbar-toggler" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">
    &#9776;
  </button>
  <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse">
    <span class="spacer"></span>
    <button class="btn btn-outline-secondary" type="button" title="Einstellungen" (click)="showSettingsModal()">
      <img src="assets/icons/sliders.svg" alt="Einstellungen" width="16" height="16" style="margin-bottom: 4px">
    </button>&nbsp;
    <button class="btn btn-outline-secondary" type="button" (click)="logout()">Abmelden</button>&nbsp;
    <app-remaining-session-time-button [expirationTime]="expirationTime" (extendToken)="extendToken()"
                                       (expired)="logout(true)"></app-remaining-session-time-button>
  </div>
</nav>

<div *ngIf="!maintenance && loggedIn" class="container-fluid">
  <div class="row">
    <div class="col-lg-5">

      <ul ngbNav #nav="ngbNav" class="nav-underline">
        <li ngbNavItem>
          <button ngbNavLink>Produktauswahl</button>
          <ng-template ngbNavContent>
            <app-products></app-products>
          </ng-template>
        </li>
        <li ngbNavItem>
          <button ngbNavLink>Gebietsauswahl</button>
          <ng-template ngbNavContent>
            <app-area-selection></app-area-selection>
          </ng-template>
        </li>
        <li ngbNavItem>
          <button ngbNavLink>Parametrisierung</button>
          <ng-template ngbNavContent>
            <app-parameters></app-parameters>
          </ng-template>
        </li>
        <li ngbNavItem>
          <button ngbNavLink>Warenkorb</button>
          <ng-template ngbNavContent>
            <app-shopping-cart></app-shopping-cart>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>

    </div>
    <div class="col-lg-7">
      <app-map></app-map>
    </div>
  </div>
</div>

<app-login *ngIf="!maintenance && !loggedIn" (loggedInEvent)="receiveEvent($event)" [displayLoginCmp]="!loggedIn"></app-login>

<footer class="footer" *ngIf="!maintenance && loggedIn">
  <img src="assets/images/GeobasisNRW-Logo_262x100.jpg" class="footer-logo" alt="Geobasis-NRW Logo">
<!--  <img src="assets/images/cop4all_90p.png" class="footer-logo" alt="Cop4ALL-NRW Logo">-->
  <span class="spacer"></span>
  <div class="flex-column">
    <div class="flex-row">
      <button *ngIf="uploadData.label" class="btn btn-outline-primary" type="button" (click)="openUploadPortal()">{{uploadData.label}}</button>&nbsp;
      <button class="btn btn-outline-secondary" type="button" (click)="openDocumentation()">Dokumentation</button>&nbsp;
      <button class="btn btn-outline-secondary" type="button" (click)="openImprint()">Impressum</button>
    </div>
    <div class="text-right" style="margin-top: 5px">
      Kontakt: <a href="mailto:cop4all@brk.nrw.de">cop4all&#64;brk.nrw.de</a>
    </div>
  </div>
</footer>
